import { Fragment } from 'react';

import PropTypes from 'prop-types';

const AccountLink = ({ accountId, text = '' }) => <Fragment>{text || accountId}</Fragment>;

AccountLink.propTypes = {
    accountId: PropTypes.number,
    text: PropTypes.string,
};

export default AccountLink;
